export default __webpack_public_path__ + "static/media/cancel-image.df6bdd51.jpg";